// api/upload.js
import request from '@/utils/request'

/**
 * 上传文件（支持多文件）
 * @param {Array<File|UploadFile>} fileList Element Plus Upload 组件返回的文件列表
 * @param {string} topic                   编码主题
 * @returns {Promise<any>}
 */
export const uploadFileAPI = (fileList, topic,function_type) => {
  console.log(fileList)
  const formData = new FormData()

  // 遍历 fileList，将每个文件追加到 FormData
  // Element Plus 的 UploadFile 对象里真实文件在 item.raw
  fileList.forEach((item) => {
    const fileObj = item.raw ? item.raw : item          // 兼容 File/UploadFile
    // 与后端字段名保持一致（若后端接收 List[UploadFile]，通常用 'files'）
    formData.append('files', fileObj)
  })

  // 追加主题字段
  formData.append('topic', topic)
  formData.append('function_type', function_type)

  return request({
    url: '/upload/file',
    method: 'post',
    data: formData,
    headers: {
      // 让浏览器自动设置 multipart 边界
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 分析文件字数
export const getFilesNumberAPI = (formData) => {
  return request({
    url: '/handle_files/upload',
    method: 'post',
    data: formData
  })
}